module.exports = __webpack_public_path__ + "04_long_black.248708a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_long_black.png
// module id = CdA4
// module chunks = 0